import { render } from "./PiaDeviceTable.vue?vue&type=template&id=07c798a1&scoped=true"
import script from "./PiaDeviceTable.vue?vue&type=script&lang=js"
export * from "./PiaDeviceTable.vue?vue&type=script&lang=js"

import "./PiaDeviceTable.vue?vue&type=style&index=0&id=07c798a1&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c798a1"]])

export default __exports__